import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'app-order-save-menu',
  templateUrl: './order-save-menu.component.html',
  styles: [
    `
      .order-save-controls {
        display: flex;
        align-items: center;
        gap: 4px;
      }
    `,
  ],
})
export class OrderSaveMenuComponent {
  @Input() orderForm: FormGroup;
  @Input() variant: 'order' | 'repair' = 'order';
  @Input() splitSave = false;
  @Output() saveOrder = new EventEmitter<{ destination: string }>();

  constructor(private auth: AuthService) {}

  get isDispensed(): boolean {
    return this.orderForm?.get('status')?.value === 'DISPENSED';
  }

  get isReturned(): boolean {
    return this.orderForm?.get('status')?.value === 'RETURNED';
  }

  get showOptionsMenu(): boolean {
    return this.isDispensed || this.isReturned;
  }

  get canDelete(): boolean {
    return this.auth?.currentUser?.role === 'OWNER/ADMIN';
  }

  onSave(destination: string): void {
    this.saveOrder.emit({ destination });
  }
}
